import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-describe-image-large.tsx
/**
* icon.24.describe.image.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE3LjUgMTlhLjUuNSAwIDAgMSAwIDFoLTRhLjUuNSAwIDAgMSAwLTF6bTMtMmEuNS41IDAgMCAxIDAgMWgtN2EuNS41IDAgMCAxIDAtMXpNMTMuMjA0IDQuMDFBMiAyIDAgMCAxIDE1IDZ2NS41YS41LjUgMCAwIDEtMSAwVjZhMSAxIDAgMCAwLTEtMUg1YTEgMSAwIDAgMC0xIDF2OGExIDEgMCAwIDAgMSAxaDYuNWEuNS41IDAgMCAxIDAgMUg1YTIgMiAwIDAgMS0xLjk5LTEuNzk2TDMgMTRWNmEyIDIgMCAwIDEgMi0yaDh6TTIwLjUgMTVhLjUuNSAwIDAgMSAwIDFoLTdhLjUuNSAwIDAgMSAwLTF6TTYuNzI1IDkuNTgyYS41LjUgMCAwIDEgLjYyOS4wNjRsMy41IDMuNWEuNS41IDAgMSAxLS43MDcuNzA3bC0zLjE0LTMuMTRhLjAxLjAxIDAgMCAwLS4wMTQgMGwtMS4xNCAxLjE0YS41LjUgMCAxIDEtLjcwNy0uNzA3bDEuNS0xLjV6TTIwLjUgMTNhLjUuNSAwIDAgMSAwIDFoLTdhLjUuNSAwIDAgMSAwLTF6TTExIDZhMiAyIDAgMSAxIDAgNCAyIDIgMCAwIDEgMC00bTAgMWExIDEgMCAxIDAgMCAyIDEgMSAwIDAgMCAwLTIiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=24953-59216
*/
const Icon24DescribeImageLarge = memo(function Icon24DescribeImageLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M17.5 19a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zm3-2a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zM13.204 4.01A2 2 0 0 1 15 6v5.5a.5.5 0 0 1-1 0V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6.5a.5.5 0 0 1 0 1H5a2 2 0 0 1-1.99-1.796L3 14V6a2 2 0 0 1 2-2h8zM20.5 15a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zM6.725 9.582a.5.5 0 0 1 .629.064l3.5 3.5a.5.5 0 1 1-.707.707l-3.14-3.14a.01.01 0 0 0-.014 0l-1.14 1.14a.5.5 0 1 1-.707-.707l1.5-1.5zM20.5 13a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zM11 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
		})
	});
});
//#endregion
export { Icon24DescribeImageLarge };

//# sourceMappingURL=icon-24-describe-image-large.js.map